import { render, staticRenderFns } from "./OpponentFilter.vue?vue&type=template&id=34b281c2"
import script from "./OpponentFilter.vue?vue&type=script&lang=js"
export * from "./OpponentFilter.vue?vue&type=script&lang=js"
import style0 from "./OpponentFilter.vue?vue&type=style&index=0&id=34b281c2&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports